import { jsx as t, Fragment as l } from "react/jsx-runtime";
import { F as u } from "../chunks/vendor_rango__assets.57b7cd48.js";
import a, { forwardRef as f } from "react";
import g, { css as m } from "styled-components";
const h = g.div.withConfig({
  displayName: "CreditCard",
  componentId: "sc-1n12d4u-0"
})(["display:flex;justify-content:center;align-items:center;width:var(--size-6x);height:var(--size-4x);border-radius:var(--border-radius-xs);background-color:var(--elements-bg-color-02);position:relative;", ""], ({
  flag: r
}) => !r && m(["&::before{position:absolute;display:block;content:'';background-color:var(--elements-bg-color-01);width:var(--size-1x);height:var(--size-half);border-radius:var(--border-radius-circular);top:var(--spacing-half);left:var(--spacing-half);}"])), p = f(({
  flag: r,
  ...n
}, i) => {
  const [s, o] = a.useState(!1);
  return a.useEffect(() => {
    const e = window.matchMedia("(prefers-color-scheme: dark)");
    function d(c) {
      o(c.matches);
    }
    return e.addEventListener("change", d), () => e.removeEventListener("change", d);
  }, []), a.useEffect(() => {
    const e = document.body.getAttribute("data-theme");
    o(e === "default-dark");
  }, [document.body.getAttribute("data-theme")]), /* @__PURE__ */ t(h, { flag: r, ...n, ref: i, "data-testid": "rango-credit-card", "data-rango-component": "rango-credit-card", "data-is-rango": !0, children: (() => {
    if (!r)
      return;
    const e = u[s ? "EloInverse" : r];
    if (e)
      return /* @__PURE__ */ t(l, { children: /* @__PURE__ */ t(e, { "data-testid": "rango-credit-card-flag" }) });
  })() });
});
p.displayName = "RangoCreditCard";
export {
  p as RangoCreditCard
};
